/** Deterministic FX randomness (11 §9): seeded from `(eventId, clientSalt=0)`
 *  so spectators and players see identical bursts; fx/ never uses the global RNG. */

function hashString(s: string): number {
  // FNV-1a 32-bit.
  let h = 0x811c9dc5
  for (let i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 0x01000193) }
  return h >>> 0
}

/** Returns a generator of numbers in [0, 1); same key → same sequence. */
export function fxRng(eventId: string | number, salt = 0): () => number {
  let x = (hashString(String(eventId)) ^ Math.imul(salt + 1, 0x9e3779b9)) >>> 0
  if (x === 0) x = 0x6d2b79f5
  return () => {
    // xorshift32
    x ^= x << 13; x >>>= 0
    x ^= x >>> 17
    x ^= x << 5; x >>>= 0
    return x / 4294967296
  }
}

/** Integer hash in [0, 2^32) for procedural textures (seeded value noise). */
export function hash2(ix: number, iy: number, seed = 0): number {
  let h = Math.imul(ix | 0, 0x27d4eb2d) ^ Math.imul(iy | 0, 0x165667b1) ^ Math.imul(seed | 0, 0x9e3779b1)
  h = Math.imul(h ^ (h >>> 15), 0x85ebca6b)
  h = Math.imul(h ^ (h >>> 13), 0xc2b2ae35)
  return (h ^ (h >>> 16)) >>> 0
}
